/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon Usage Calculator — Toolverse`)
};

const es_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Uso de Codones — Toolverse`)
};

const de_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon-Nutzungsrechner — Toolverse`)
};

const nl_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codongebruikcalculator — Toolverse`)
};

const fr_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur d'usage des codons — Toolverse`)
};

const it_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore dell'uso dei codoni — Toolverse`)
};

const pt_br2_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Uso de Códons — Toolverse`)
};

const pt_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Uso de Codões — Toolverse`)
};

const ja_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コドン使用頻度計算ツール — Toolverse`)
};

const zh_codon_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码子使用计算器 — Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_meta_title", locale)
	if (locale === "en") return en_codon_meta_title(inputs)
	if (locale === "es") return es_codon_meta_title(inputs)
	if (locale === "de") return de_codon_meta_title(inputs)
	if (locale === "nl") return nl_codon_meta_title(inputs)
	if (locale === "fr") return fr_codon_meta_title(inputs)
	if (locale === "it") return it_codon_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_codon_meta_title(inputs)
	if (locale === "pt") return pt_codon_meta_title(inputs)
	if (locale === "ja") return ja_codon_meta_title(inputs)
	return zh_codon_meta_title(inputs)
};